// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OsCF","title":"Header_title__CJ7e0","left":"Header_left__2QIzg","clinicName":"Header_clinicName__1M9H-"};